import { FunctionComponent } from 'react';
import { Person, Requirement } from '../../types';
import { DelawareAnnualReport } from './DelawareAnnualReport_NEW';
import { DefaultAnnualReport } from './DefaultAnnualReport_NEW';

type AnnualReportProps = {
  locationId: string;
  requirement: Requirement;
  peopleData: Person[];
  onEnterLater: () => void;
  onSubmitSuccess: () => void;
  isFullWidth?: boolean;
  scrollOnMount?: boolean;
};

export const AnnualReportNew: FunctionComponent<AnnualReportProps> = ({
  locationId,
  requirement,
  peopleData,
  onEnterLater,
  onSubmitSuccess,
  isFullWidth,
  scrollOnMount,
}) => {
  if (locationId === 'de') {
    return (
      <DelawareAnnualReport
        locationId={locationId}
        requirement={requirement}
        peopleData={peopleData}
        onEnterLater={onEnterLater}
        onSubmitSuccess={onSubmitSuccess}
        isFullWidth={isFullWidth}
        scrollOnMount={scrollOnMount}
      />
    );
  }

  return (
    <DefaultAnnualReport
      locationId={locationId}
      requirement={requirement}
      peopleData={peopleData}
      onEnterLater={onEnterLater}
      onSubmitSuccess={onSubmitSuccess}
      isFullWidth={isFullWidth}
      scrollOnMount={scrollOnMount}
    />
  );
};
